<template>
  <div class="details">
    <van-nav-bar
      class="navt"
      title="订单详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
      <div class="dnum">
            <span>下单时间 ： </span>{{$route.params.id.addtime}}
          </div>
    <div class="">
      <img
        src="../../assets/bottom-bj.jpg"
        alt=""
      ></div>
    <div class="address">
      <p class="top"><span class="name">{{$route.params.id.realname}}</span><span style="float:right">{{$route.params.id.mobile}}</span></p>
      <p class="bottom">{{$route.params.id.prov+$route.params.id.city+$route.params.id.dist+$route.params.id.address_detail}}</p>
      <div class="more">

      </div>

    </div>
    <div class="">
      <img
        src="../../assets/bottom-bj.jpg"
        alt=""
      ></div>
    <div class="datails">
      <div class="shop">{{$route.params.id.store_name}} <span>{{$route.params.id.order_id}}</span> 
      <div class="fr li">
{{$route.params.id.order_status}}
      </div>
       </div>
      <div class="top">
        <div
          class="card "
          v-for="(v,i) in $route.params.id.goods"
          :key="i"
          @click="go(v)"
        >
          <van-card>
            <template #thumb>
              <img
                class="imgs"
                :src="v.sku_thumb"
                alt=""
              >
            </template>
            <template #title>
              <div class="title">{{v.name}}</div>
            </template>
            <template #price>
              <div class="price">￥{{v.goods_price}}</div>
            </template>
          </van-card>
          <div class="close">

            <p></p>
            <p>x{{v.goods_num}}</p>

          </div>
        </div>

        <!-- <div class="num">
          <p>是否开具发票</p>
          <span>{{$route.params.id.is_bill}}</span>
          <div class="more">

          </div>
        </div> -->
        <div class="v_field">
          <p>买家留言：</p>

          <textarea
            disabled
            v-model="$route.params.id.remark"
            class="field"
            maxlength=45
            placeholder="选填：留言请在45字之内"
          ></textarea>
        </div>
        <div class="prices">
          <div class="p_num"> 共计：<span>{{$route.params.id.goods.length}}</span>件商品</div>
        </div>
        <div class="statistics">
          <div class="num">
            <p>货物总金额</p>
            <span>￥{{$route.params.id.total_price}} </span>
          </div>
           <div class="num">
            <p>- 鲸点返利</p>
            <span> ￥{{$route.params.id.use_fanli_money}} </span>
          </div>
            <div class="num">
            <p>- 优惠劵</p>
            <span> ￥{{$route.params.id.money}} </span>
          </div>
          <div class="num">
            <p>+ 运费</p>
            <span> ￥{{$route.params.id.freight}} </span>
          </div>
        
          <div class="num">
            <p>- 整单折让</p>
            <span> ￥{{$route.params.id.total_discount_money}} </span>
          </div>
         
          <div class="num">
            <p>本单应付款</p>
            <span>￥{{$route.params.id.order_jiesuan_money}} </span>
          </div>
          <hr>
        
        </div>
        <p  style="color: #d0111b; font-size: 0.35rem; padding-left: 0.2rem; padding-top: 0.2rem;" v-show="$route.params.id.use_jingxinyong_money>0">本单使用鲸信用:￥{{$route.params.id.use_jingxinyong_money}}</p>
      </div>
      <div class="buts">

        <div class="but">
          <van-button
            type="danger"
            size="small"
            class="v_but"
            @click="buy"
v-show="$route.params.i==1"
          >立即付款</van-button>
          <!-- <van-button
            v-show="$route.params.i==1"
            color="#666"
            size="small"
            class="v_but"
            @click="ash"
          >取消订单</van-button>
          <van-button
            v-show="$route.params.i==2 ||$route.params.i==3 ||$route.params.i==4"
            color="#666"
            size="small"
            class="v_but"
            @click="delet"
          >删除订单</van-button>
          <van-button
            type="danger"
            v-show="$route.params.i==3"
            size="small"
            class="v_but"
            @click="back"
          >申请退货</van-button> -->
          <!-- <div
            v-show="$route.params.i!=1"
            class="cs"
          >订单已超过24小时未支付，已经取消！</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Toast,
  Icon,
  Card, Stepper, Button, Field, Popup, Dialog
} from 'vant'

Vue.use(NavBar)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast).use(Icon)
  .use(Card)
  .use(Stepper)
  .use(Button).use(Field).use(Popup).use(Dialog)
export default {
  created () {
    if(this.$route.params.id){}else{
      this.$router.push('/my')
    }
    this.$route.params.id.goods.forEach(v => {
      this.txt += v.goods_num
    })
  },
  data () {
    return {
      address: { name: 'name', address: "address", tel: "mobile" },
      txt: 0,
      mobile: ""
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    buy () {
      this.$router.push({ name: 'cashier', query: { money: this.$route.params.id.order_jiesuan_money, sid: this.$route.params.id.store_id ,order:this.$route.params.id.id} })
    },
    go (v) {
      // console.log(this.$route.params.id.changjia)
      // return
      // if (this.$route.params.id.changjia == 1) {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1, c: 1 } })
      // } else {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1 } })
      // }
    },
    ash () {
      Dialog.confirm({
        title: '是否确认取消订单',
        message: '',
      }).then(() => {
        this.axios.post('cancel_order', { id: this.$route.params.id.id }).then(res => {
          if (res.data.code == 1004) {
            localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
            this.ash()
          }
          // console.log(res)
          Toast(res.data.msg)
          this.$router.go(-1)
          done()
        }).catch(ref => { })

      }).catch(() => {

      })
    },
    delet () {
      Dialog.confirm({
        title: '是否删除取消订单',
        message: '',
      }).then(() => {
        this.axios.post('del_order', { id: this.$route.params.id.id }).then(res => {
          if (res.data.code == 1004) {
            localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
            this.delet()
          }
          // console.log(res)
          Toast(res.data.msg)
          this.$router.go(-1)
          done()
        }).catch(ref => { })
      }).catch(() => { })
    },
    back () {

      this.axios.post('goods_back', { store_id: this.$route.params.id.store_id }).then(res => {
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.back()
        }
        // console.log(res)
        // Toast(res.data.msg)
        Dialog.confirm({
          title: '请联系业务员退货',
          message: res.data.data.mobile,
          confirmButtonText: '呼叫'
        }).then(() => {
          window.location.href = "tel:" + res.data.data.mobile
        }).catch(ref => { })
      }).catch(ref => { })

    }
  }
}
</script>
<style lang="less" scoped>
.details {
  padding-top: 1.2rem;
  background-color: #f1f1f1;
}
.navt {
  width: 100%;
  position: fixed;
  top: 0;
}
.address {
  position: relative;
  padding: 0.4rem;
  width: 100%;
  height: 2rem;
  background-color: #fefcee;
  .top {
    height: 0.76rem;
    .name {
      padding-right: 2rem;
      font-size: 0.426667rem;
    }
  }
  .bottom {
    font-size: 0.373333rem;
    color: #888;
  }
}
.cs {
  text-align: center;
  line-height: 1.3rem;
  color: red;
}
.dnum {
  font-size: 0.4rem;
  background-color: #fff;
  line-height: 0.8rem;
  padding-left: 0.3rem;
  span {
    color: #666;
  }
}
.datails {
  margin-top: 0.266667rem;
  background-color: #fff;
  .shop {
    padding: 0.426667rem;
    color: #a22d2b;
    font-size: 0.426667rem;
    border-bottom: 0.03rem solid #dfdfdd;
    span{
      color: #666;
      font-size: 0.35rem;
    }
    .li{
      font-size: 0.4rem;
    }
  }
  .top {
    position: relative;
    background-color: #fff;
    width: 100%;
    padding-bottom: 2.3rem;
    .card {
      border-bottom: 0.03rem solid #dfdfdd;
      .van-card {
        background-color: #fff;
        padding-bottom: 0;
      }

      width: 100%;
      position: relative;
      padding-top: 0.2rem;
    }
    .title {
      padding-top: 0.2rem;
      font-size: 0.34rem;
    }
    .imgs {
      width: 2rem;
      height: 2rem;
    }
    .price {
      color: #e02828;

      font-size: 0.5rem;
      padding-bottom: 0.64rem;
    }
    .close {
      text-align: right;
      font-size: 0.4rem;
      // color: #d3d;
      position: absolute;
      right: 35%;
      top: 60%;
      background-color: #fff;
    }

    .num {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      display: flex;
      position: relative;
      span {
        text-align: right;
        width: 4rem;
        overflow: hidden; /*超过部分不显示*/
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 0.85rem;
        font-size: 0.35rem;
        padding-right: 10%;
      }
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
        flex: 1;
      }
      .stepper {
        flex: 1;
        text-align: right;
      }
    }
    .v_field {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
      }
      .field {
        background-color: #f1f1f1;
        width: 100%;
        border: none;
        height: 1.2rem;
        text-indent: 0.2rem;
        resize: none;
        padding-top: 0.2rem;
      }
    }
    .prices {
      padding: 0.35rem 0.5rem;
      text-align: right;
      .p_num {
        // font-size: 0.4rem;
        color: #666;
        span {
          // font-size: 0.48rem;
          color: #a22d28;
          // padding-right: 0.5rem;
        }
      }
    }
  }
  .statistics {
    background-color: #dfdfdf;
    // margin-top: 1rem;
    height: 5.5rem;
    width: 100%;
    padding-top: 0.2rem;
    .num {
      border: none;
      padding: 0 0 0 0.3rem;
      background-color: #fff;
      span {
        color: #d0111b;
      }
    }
  }
  .buts {
    width: 100%;
    position: fixed;
    bottom: 0;
    border-top: 0.03rem solid #dfdfdf;
    background-color: #fff;
  }
  .but {
    display: flex;
    flex-direction: row-reverse;
    .v_but {
      width: 25%;
      margin: 0.2rem;
    }
  }
}
</style>